export var colorGrey90 = '#161616';
export var colorGrey80 = '#242424';
export var colorGrey70 = '#333333';
export var colorGrey60 = '#4D4D4D';
export var colorGrey60WithOpacity = '#3D3D3D';
export var colorGrey50 = '#6B6B6B';
export var colorGrey40 = '#878787';
export var colorGrey30 = '#A3A3A3';
export var colorGrey20 = '#C2C2C2';
export var colorGrey10 = '#DBDBDB';
export var colorGrey05 = '#F4F4F4';
export var colorGrey01 = '#fcfcfc';
export var colorGrey00 = '#ffffff';
export var colorBlue90 = '#0a39b7';
export var colorBlue80 = '#124ac2';
export var colorBlue70 = '#1654C8';
export var colorBlue60 = '#1C5ECE';
export var colorBlue50 = '#2067D3';
export var colorBlue40 = '#417fda';
export var colorBlue30 = '#6295e0';
export var colorBlue20 = '#8FB3E9';
export var colorBlue10 = '#bbd1f2';
export var colorBlue05 = '#eef4fc';
export var colorTurquoise90 = '#048670';
export var colorTurquoise80 = '#029379';
export var colorTurquoise70 = '#019C83';
export var colorTurquoise60 = '#02A68E';
export var colorTurquoise50 = '#00ad96';
export var colorTurquoise40 = '#26b9a6';
export var colorTurquoise30 = '#4cc6b6';
export var colorTurquoise20 = '#80d6cb';
export var colorTurquoise10 = '#b4e6e0';
export var colorTurquoise05 = '#e1f5f2';
export var colorYellow90 = '#ec9800';
export var colorYellow80 = '#efa600';
export var colorYellow70 = '#f1ae00';
export var colorYellow60 = '#F3B701';
export var colorYellow50 = '#f3bd02';
export var colorYellow40 = '#f5c825';
export var colorYellow30 = '#f7d14d';
export var colorYellow20 = '#fade80';
export var colorYellow10 = '#ffecb3';
export var colorYellow05 = '#fef7e0';
export var colorGreen90 = '#64b72c';
export var colorGreen80 = '#76c23d';
export var colorGreen70 = '#7fc847';
export var colorGreen60 = '#8BCE4F';
export var colorGreen50 = '#93d357';
export var colorGreen40 = '#a3da70';
export var colorGreen30 = '#b3e088';
export var colorGreen20 = '#c9e9ab';
export var colorGreen10 = '#DFF2CD';
export var colorGreen05 = '#f2faeb';
export var colorRed90 = '#c82a32';
export var colorRed80 = '#d1323a';
export var colorRed70 = '#D73D45';
export var colorRed60 = '#E5434a';
export var colorRed50 = '#e44b52';
export var colorRed40 = '#e8656c';
export var colorRed30 = '#ec8086';
export var colorRed20 = '#f2a5a9';
export var colorRed10 = '#F7C9CB';
export var colorRed05 = '#fce9ea';
export var colorPurple50 = '#673ab7';
export var colorPurple20 = '#b39ddb';